import styled from "styled-components"

const Container = styled.div`
    font-size: 20px;
    text-align: center;
    font-weight: bold;
    width: 200px;
    margin: 20px auto 15px auto;
    padding: 0 15px;
    border: 1px solid orange;
    border-radius: 5px;
`

type LabelProps = {
    children: string,
}

export const Label = ({ children }: LabelProps) => {
    return <Container>{children}</Container>
}